
import React from 'react';
import SetoCanvasPage from 'pages/SetoCanvasPage';

import VisaCheckoutForm from 'views/order/VisaCheckoutForm';

import Tabs from 'muicss/lib/react/tabs';
import Tab from 'muicss/lib/react/tab';

import AppUtil from 'AppUtil';
import AppConstants from 'AppConstants';
import QRCodeForm from 'views/QRCodeForm';

import SessionStore from 'stores/SessionStore';
import {useUserActiveOrders} from 'hooks/OrderHook';
import {A} from 'views/AppElements';

const TAB_VALUES = ["QR_CODE_SCAN", "ESEWA", "BANK_TRANSER"];


export const PaymentConfirmationDM = () => {
    return <ul className="dmSources">
                <li><a target="_blank" href="https://m.me/setocanvascom">Messenger</a></li>
                <li><a target="_blank" href={AppConstants.INSTA_PAGE}>Instagram</a></li>
                <li>or, <span style={{color: "green"}}>WhatsApp</span> at {AppConstants.WHATS_APP}</li>
            </ul>
}

const EsewaIdPayment = ({amount}) => {

    return <div id="esewaIdForm" className="paymentForm">

            <ul>
                <li>Send to Esewa Id: <b>9862441133</b>, Name: <b>Se*****</b></li>
                {
                    (amount !== null && amount !== undefined && amount > 0) &&
                    <li>Enter Amount: <b>{"Rs. "+AppUtil.formatNumber(amount)}</b></li>
                }
                <li>Enter Purpose: <b>Bill Sharing</b>.</li>
                <li>Enter Remarks: <b>Your Name</b> <i><small>(same as in your order)</small></i>.</li>
                <li>After finishing your payment, DM Us it's screenshot and our operator shall confirm and mark your order paid. You can send the screenshot in:</li>
                <PaymentConfirmationDM />
            </ul>
    </div>
};

const BankTransferPayment = ({amount}) => {

    return <div id="bankTransferForm" className="paymentForm">
            <ul>
                <li>Bank Name: <b>NIC Asia Bank, Kapan Branch</b></li>
                <li>Account Id: <b>0604150047260002</b></li>
                <li>Account Name: <b>SETO CANVAS PVT. LTD.</b></li>
                {
                    (amount !== null && amount !== undefined && amount > 0) &&
                    <li>Amount: <b>{"Rs. "+AppUtil.formatNumber(amount)}</b></li>
                }
                <li>After finishing your payment, DM Us it's screenshot and our operator shall confirm and update your order. You can send the screenshot in:</li>
                <PaymentConfirmationDM />
            </ul>
        </div>
};

const CardPayment = ({amount, orderIds}) => {


    return <div id="cardPaymentForm" className="paymentForm" >
            <ul>
            <li>You can use your <i className="fa fa-cc-visa" aria-hidden="true"/> Visa or <i className="fa fa-cc-mastercard" aria-hidden="true" /> Master Card to make the payment.</li>
            {
                (amount !== null && amount !== undefined && amount > 0) &&
                <li>Total Amount: <b>{"Rs. "+AppUtil.formatNumber(amount)}</b></li>
            }
            <li>
                Clicking on the <b>'Continue'</b> button will redirect you to a secure payment page where you can enter your card details to make the payment.
            </li>
        </ul>
        <VisaCheckoutForm amount={amount} orderIds={orderIds} />
    </div>
}

const CheckoutPage = (props) => {
    const currentSession = SessionStore.getCurrentSession();
    const queryParams = AppUtil.getUrlQueryParams(props.location);

    const tabIndex = TAB_VALUES.indexOf(queryParams['via']);

    let amount = queryParams['amount'];
    let orderIds = queryParams['orderId']? queryParams['orderId'].split(",").map(o => parseInt(o, 10)): [];

    if(!amount || !orderIds) {
        if(currentSession) {
            const orders = useUserActiveOrders();

            if(orders) {
                const unpaidOrderFilter = (o) => o.orderState !== 'DELIVERED' && o.orderState !== 'CANCELLED' && !o.paid;

                orderIds = orders.filter(unpaidOrderFilter)
                                .map(o => o.orderId).toArray();
                                
                amount = orders.filter(unpaidOrderFilter)
                                .map(o => o.totalCharge).reduce((a, b) => a+b, 0);
            }
        }
        
    }

    return (
        <SetoCanvasPage id="checkoutPage" title={"Checkout Artworks, Merchandise, T-Shirt, Hoodies and more | Seto Canvas"} 
						metaDescription={"Checkout tshirts, arts and many more at SetoCanvas.com"} >
            
            <div className="flexRow" id="checkoutHeader">
                <h2 id="selectPaymentTxt">Select Payment Method</h2>

                {
                currentSession &&
                    <div className="viewOrdersLink" >
                        <A href="/orders"><i className="fa fa-long-arrow-left" aria-hidden="true" /> View Orders</A>
                    </div>
                }
            </div>
            
            <Tabs defaultSelectedIndex={tabIndex > 0? tabIndex: 0} style={{minHeight: '300px'}}>

                <Tab value={TAB_VALUES[0]} label={<span><i className="fa fa-qrcode" aria-hidden="true" /> QR Code Scan</span>}>
                    <QRCodeForm amount={amount}/>
                </Tab>

                <Tab value={TAB_VALUES[1]} label="eSewa">
                    <EsewaIdPayment amount={amount}/>
                </Tab>

                <Tab value={TAB_VALUES[2]} label={<span><i className="fa fa-university" aria-hidden="true" /> Bank Transfer</span>}>
                    <BankTransferPayment amount={amount}/>
                </Tab>

                {/* <Tab value={TAB_VALUES[3]} label={<span><i className="fa fa-credit-card" aria-hidden="true" /> Credit/Debit Card</span>}>
                    <CardPayment amount={amount} orderIds={orderIds} />
                </Tab> */}
            </Tabs>
            
        </SetoCanvasPage>
    );
};

export default CheckoutPage;


// WEBPACK FOOTER //
// ./src/pages/CheckoutPage.js